export default __webpack_public_path__ + "static/media/redeemimg.eb746dd7.png";